import React from 'react'
import superagent from 'superagent'
import { string, object, array } from 'prop-types'
const getAirportInfo = require('../getAirportInfo')

class VideoList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      items: []
    }
  }

  componentDidMount () {
    const feedInfo = this.getWistiaInfoFromFeed()
    this.getVideoInfo(feedInfo)
  }

  shouldComponentUpdate (nextState, nextProps) {
    if (JSON.stringify(nextState.items) !== JSON.stringify(this.state.items)) return true
    if (nextProps.id !== this.props.id) return true
    if (nextProps.pageData.pageName !== this.props.pageData.pageName) return true
    return false
  }

  setVideoInfo () {
    this.setState({
      items: this.props.videoInfo
    })
  }

  getType (productClass) {
    if (productClass === 'HCP' || productClass === 'HO') return 'hotelWistiaKeys'
    return 'parkingWistiaKeys'
  }

  getWistiaInfoFromFeed () {
    const { pageData: { productClass, pageName } } = this.props
    const location = getAirportInfo(pageName)
    const type = this.getType(productClass.toUpperCase())
    try {
      let data = require('../../../../../config/exports/buildTimeOnly/videoData/' + type + '/' + location.code + '.json')
      return data
    } catch (e) {
      return false
    }
  }

  getVideoInfo (prodlib) {
    if (this.props.videoInfo) {
      this.setVideoInfo()
      return
    }
    const promises = Object.keys(prodlib).map(key => {
      const item = prodlib[key]
      if (!item || !item.name || !item.wistia_key) return
      return new Promise((resolve, reject) => {
        superagent.get('https://fast.wistia.com/oembed/?url=https://home.wistia.com/medias/' + item.wistia_key)
        .query({format: 'json'})
        .end((err, resp) => {
          if (err) return reject(err)
          const result = {item, resp}
          resolve(result)
        })
      })
    })
    Promise.all(promises).then(items => {
      this.setState({
        items
      })
    })
  }

  injectFrame (e) {
    const element = e.target.parentElement
    const wistiaKey = e.target.getAttribute('data-wistia-key')
    const frameSrc = '//fast.wistia.net/embed/iframe/' + wistiaKey + '?videoFoam=true&autoPlay=true'
    element.innerHTML = '<iframe src="' + frameSrc + '" allowTransparency="true" frameBorder="0" scrolling="no" class="wistia_embed" name="wistia_embed" allowFullScreen mozallowfullscreen webkitallowfullscreen oallowfullscreen msallowfullscreen width="100%"></iframe>'
  }

  getVideoHtml () {
    const { items } = this.state
    if (!items.length) return null
    return items.map((data, id) => {
      let { item, resp } = data
      resp = JSON.parse(resp.text)
      const placeholderUrl = resp.thumbnail_url.replace(/\?(.+)$/g, '') + '?image_resize=700&image_play_button=true&image_play_button_color=50b1f2'
      return (
        <div key={id} className='wistia-video'>
          <h2>{ item.name }</h2>
          <div id={'wistia-image-' + id} className='inner'>
            <img src={placeholderUrl} data-wistia-key={item.wistia_key} onClick={this.injectFrame} />
          </div>
        </div>
      )
    })
  }

  render () {
    const html = this.getVideoHtml()
    return (
      <div id={this.props.id}>
        {html}
      </div>
    )
  }
}

VideoList.propTypes = {
  pageData: object.isRequired,
  id: string,
  videoInfo: array
}

export default VideoList



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/multimedia/video-list.jsx